// Mirror of the backend's EmailHandlersRegistry keys + ADDITIONAL_SUPPRESSIBLE_EMAIL_NAMES.

// TODO: remove this hardcoded list and source from the backend once all suppressible emails live in EmailHandlersRegistry and this data is returned by the metadata endpoint or a program-independent endpoint.
export const SUPPRESSIBLE_EMAIL_NAMES = [
  'AdobeDuplicateNomination',
  'AdobeNonprofitOnboarding',
  'AdobeNonprofitOnboardingComplete',
  'AdyenNominationApproved',
  'AdyenNominationDeclined',
  'AdyenNonprofitOnboarding',
  'ApplicationRejection',
  'ActionAwardNominator',
  'AwardNominator',
  'AwardLetter',
  'AwardLetterAdhoc',
  'LululemonNominationEligible',
  'LululemonNominationIneligible',
  'LululemonOrganizationOnboarding',
  'LululemonOrganizationOnboardingComplete',
  'LululemonRegistrationComplete',
  'LululemonRegistrationInvite',
  'LululemonUnsuccessfulRegistration',
  'NominationRejection',
  'NonprofitOnboarding',
  'NonprofitOnboardingRegionalPhilanthropy',
  'OnboardingReminder',
  'PaymentConfirmation',
  'TwilioOnboarding',
  // Additional names not yet in the registry but accepted by the backend:
  'ApplicationReceipt',
  'NominationReceipt'
] as const

export type SuppressibleEmailName = typeof SUPPRESSIBLE_EMAIL_NAMES[number]
